import React, { useState, useEffect } from "react";
import getStyles from "./styles";
import SearchBar from "./SearchBar";
import UsersTable from "./UsersTable";
import MainContainer from "../MainContainer";
import type { IAdminPanelProps, User } from "../../types";
import { useAppDispatch, useAppSelector } from "../../redux";
import {
  selectUsers,
  getUsersAction,
  clearFilteredUsers,
  getUserImagesAction,
  getSingleUserAction,
  selectFilteredUsers,
  selectNumberOfEntries,
  selectPermissions,
} from "../Dashboard/DashboardSlice";

export default function _AdminPanel(props: IAdminPanelProps) {
  const { images, isAuthentication, page, setPage } = props;

  const styles = getStyles();

  const dispatch = useAppDispatch();

  const users = useAppSelector(selectUsers);
  const filteredUsers = useAppSelector(selectFilteredUsers);
  const numberOfEntries = useAppSelector(selectNumberOfEntries);
  const permissions = useAppSelector(selectPermissions);

  const [registrationNumber, setRegistrationNumber] = useState<number | null>(null);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);

  useEffect(() => {
    handleClearFilteredUsers();
    const start = async () => {
      async function getData() {
        await dispatch(getUsersAction("0"));
      }
      if (permissions?.entrie) await getData();
    };

    start();
  }, []);

  const handleRegistrationNumberChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.currentTarget;

    if (!value || isNaN(Number(value))) return setRegistrationNumber(null);

    setRegistrationNumber(Number(value));
  };

  const handleClearFilteredUsers = () => {
    setRegistrationNumber(null);
    dispatch(clearFilteredUsers());
  };

  const filterUsers = async (event: React.FormEvent) => {
    event.preventDefault();

    await dispatch(getSingleUserAction(String(registrationNumber)));
  };

  const handleSetSelectedUser = async (user: User) => {
    await dispatch(getUserImagesAction(String(user.UserInfo.id)));

    setSelectedUser(user);
  };

  const handleChangePage = async (_: any, newPage: number) => {
    await dispatch(getUsersAction(String(newPage)));
    setPage(newPage);
  };

  return (
    <>
      <MainContainer title="" titleVariant="h4">
        <SearchBar
          registrationNumber={registrationNumber}
          filteredUsers={filteredUsers}
          styles={styles}
          filterUsers={filterUsers}
          handleClearFilteredUsers={handleClearFilteredUsers}
          handleRegistrationNumberChange={handleRegistrationNumberChange}
        />

        <UsersTable
          page={page}
          numberOfEntries={numberOfEntries}
          users={users}
          filteredUsers={filteredUsers}
          styles={styles}
          handleSetSelectedUser={handleSetSelectedUser}
          handleChangePage={handleChangePage}
        />
      </MainContainer>
    </>
  );
}
